import { TextsLanguages } from '@types'

export const useTexts = (lang: TextsLanguages = 'pt-br') => {
  const texts = {
    'pt-br': {
      serviceWorker: {
        message: 'Nova versão disponível! Por favor, recarregue a página.',
        action: 'Atualizar',
      },
    },
  }

  return texts[lang]
}
